"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordInput = PasswordInput;

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _collapse = require("../../collapse");

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _media = require("react-components/media");

var _typography = require("../../typography");

var _styles = require("react-components/styles");

var _regex = require("@slyk/regex");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _zxcvbn2 = _interopRequireDefault(require("zxcvbn"));

var _excluded = ["className", "disabled", "hasRequirements", "helpText", "id", "label", "name", "passwordRegex", "passwordRequirements"],
    _excluded2 = ["error", "meta", "onChange", "value"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var eyeClosedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M2.162 9.158v1.973c0 .823.415 1.607 1.138 2.151l.893.673c.612.46 1.4.715 2.215.715h11.367a3.7 3.7 0 002.214-.715l.894-.673c.723-.544 1.137-1.328 1.137-2.151V9.158\"/></svg>";
var eyeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M15.286 9.52c-1.11-1.59-5.282-1.589-6.39 0-.357.51-.535 1.388-.535 2.634 0 1.245.179 2.122.535 2.633 1.072 1.536 5.29 1.64 6.39.063.357-.511.535-1.41.535-2.696 0-1.246-.179-2.124-.535-2.634zm2.487 8.578a3.39 3.39 0 002.215-.82l.894-.772a3.261 3.261 0 001.137-2.468v-3.76a3.26 3.26 0 00-1.137-2.467l-.894-.772a3.39 3.39 0 00-2.215-.82m-11.365 0a3.39 3.39 0 00-2.215.82L3.3 7.81a3.261 3.261 0 00-1.138 2.468v3.758A3.26 3.26 0 003.3 16.505l.893.772c.612.528 1.4.82 2.215.82\"/></svg>";

/**
 * Requirements order.
 */
var requirementsOrder = ['lowercase', 'uppercase', 'number', 'size'];
/**
 * Strength color themes.
 */

var strengthColorThemes = {
  score0: (0, _styles.color)('danger'),
  score1: (0, _styles.color)('danger'),
  score2: (0, _styles.color)('gray400'),
  score3: (0, _styles.color)('success'),
  score4: (0, _styles.color)('success')
};
/**
 * `Props` type.
 */

/**
 * `InputWrapper` styled component.
 */
var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "password-input__InputWrapper",
  componentId: "sc-2xnf0y-0"
})(["flex:1;"]);
/**
 * `RequirementsList` styled component.
 */


var RequirementsList = _styledComponents["default"].ul.withConfig({
  displayName: "password-input__RequirementsList",
  componentId: "sc-2xnf0y-1"
})(["border:1px solid ", ";border-radius:6px;display:grid;grid-template-columns:repeat(4,1fr);"], (0, _styles.color)('gray300'));
/**
 * `RequirementsListItem` styled component.
 */


var RequirementsListItem = _styledComponents["default"].li.withConfig({
  displayName: "password-input__RequirementsListItem",
  componentId: "sc-2xnf0y-2"
})(["align-items:center;border-right:1px solid ", ";color:", ";padding:20px 4px 16px;text-align:center;&:last-child{border-right:none;}*{display:block;}", ""], (0, _styles.color)('gray300'), (0, _styles.color)('gray500'), (0, _styledTools.ifProp)('isValid', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('primary'))));
/**
 * `PasswordStrength` styled component.
 */


var PasswordStrength = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'div',
  size: 'normal'
}).withConfig({
  displayName: "password-input__PasswordStrength",
  componentId: "sc-2xnf0y-3"
})(["padding:0 8px;text-transform:uppercase;", ""], function (_ref) {
  var level = _ref.level;
  return (0, _styledComponents.css)(["color:", ";"], strengthColorThemes[level]);
});
/**
 * `ShowHideButton` component.
 */

var ShowHideButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "password-input__ShowHideButton",
  componentId: "sc-2xnf0y-4"
})(["appearance:none;background-color:transparent;border:0;color:", ";cursor:pointer;display:inline-block;height:24px;margin:10px 11px 10px 0;padding:0;transition:color ", ";", " &:focus,&:hover{color:", ";}&:disabled{color:", ";}"], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 15px 13px 13px 0;\n  "]))), (0, _styles.color)('nightBlue600'), (0, _styles.color)('gray400'));
/**
 * Is valid requirement.
 */


function isValidRequirement(requirement, value, passwordRequirements) {
  var requirements = passwordRequirements !== null && passwordRequirements !== void 0 ? passwordRequirements : _regex.passwordRequirements;
  var requirementRegex = new RegExp(requirements[requirement]);
  return requirementRegex.test(value);
}
/**
 * Get score.
 */


function getScore(value, passwordRegex) {
  if (!new RegExp(passwordRegex !== null && passwordRegex !== void 0 ? passwordRegex : _regex.password).exec(value)) {
    return -1;
  }

  var _zxcvbn = (0, _zxcvbn2["default"])(value),
      score = _zxcvbn.score;

  return score;
}
/**
 * Export `PasswordInput` component.
 */


function PasswordInput(props) {
  var className = props.className,
      disabled = props.disabled,
      _props$hasRequirement = props.hasRequirements,
      hasRequirements = _props$hasRequirement === void 0 ? false : _props$hasRequirement,
      helpText = props.helpText,
      id = props.id,
      label = props.label,
      name = props.name,
      passwordRegex = props.passwordRegex,
      passwordRequirements = props.passwordRequirements,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      onChange = _useField.onChange,
      value = _useField.value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _ref2 = meta !== null && meta !== void 0 ? meta : {},
      active = _ref2.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  var isFloatingLabel = Boolean(value) || active;
  var handleChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    onChange((0, _isEmpty2["default"])(value) ? undefined : value);
  }, [onChange]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var toggleVisibility = (0, _react.useCallback)(function () {
    setVisible(!visible);
  }, [setVisible, visible]);
  var score = (0, _react.useMemo)(function () {
    return getScore(value, passwordRegex);
  }, [passwordRegex, value]);
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormControlWrapper, {
    disabled: isDisabled,
    hasError: hasError,
    hasFocus: active
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.Label, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isFloating: isFloatingLabel
  }, label), /*#__PURE__*/_react["default"].createElement(InputWrapper, null, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormControl, _extends({
    disabled: isDisabled,
    id: id !== null && id !== void 0 ? id : name,
    name: name,
    onChange: handleChange,
    value: value !== null && value !== void 0 ? value : '',
    variant: 'input'
  }, rest, fieldProps, {
    type: visible ? 'text' : 'password'
  }))), hasRequirements && !(0, _isNil2["default"])(score) && score >= 0 && /*#__PURE__*/_react["default"].createElement(PasswordStrength, {
    level: score
  }, translate("forms.passwordInput.strength.score".concat(score))), /*#__PURE__*/_react["default"].createElement(ShowHideButton, {
    "aria-label": translate("forms.passwordInput.".concat(visible ? 'hidePassword' : 'showPassword')),
    disabled: isDisabled,
    onClick: toggleVisibility,
    visible: visible
  }, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    icon: visible ? eyeClosedIcon : eyeIcon,
    size: '24px'
  }))), hasRequirements && /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    isOpen: active || value
  }, /*#__PURE__*/_react["default"].createElement(RequirementsList, null, requirementsOrder.map(function (requirement) {
    return /*#__PURE__*/_react["default"].createElement(RequirementsListItem, {
      isValid: isValidRequirement(requirement, value !== null && value !== void 0 ? value : '', passwordRequirements),
      key: requirement
    }, /*#__PURE__*/_react["default"].createElement(_typography.Text, {
      size: 'small'
    }, translate("forms.passwordInput.requirements.".concat(requirement, ".symbol"))), /*#__PURE__*/_react["default"].createElement(_typography.Text, {
      size: 'small'
    }, translate("forms.passwordInput.requirements.".concat(requirement, ".label"))));
  }))), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}